import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/management/restrictUser/filter'; // Importing Filter component
import Table from 'views/management/restrictUser/table'; // Importing Table component
import { devConfig } from '../config/config'; // Importing development configuration

/**
 * MenuView class extending JetView to create a user restriction management interface.
 */
export default class MenuView extends JetView {
    /**
     * Configures the UI components of the MenuView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Columns within the toolbar
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70, // Width of the select box
                    on: {
                        // Event handlers
                        onChange: function () {
                            // Change event for page size
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                            $$('datatable').scrollTo(100, 0); // Scroll to the top
                            vthis.app.callEvent('changeSize', [{}]); // Trigger change size event
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    // Template for pager buttons
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    animate: {
                        // Animation settings
                        subtype: 'out',
                    },
                    size: devConfig.getDefaultDataFetch(), // Default page size from config
                },
                {
                    view: 'richselect', // Rich select for export options
                    name: 'Export', // Name of the select
                    id: 'Export', // Unique identifier for the export select
                    width: 120, // Width of the rich select
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' },
                        { id: '2', value: 'PDF' },
                    ],
                    on: {
                        // Event handlers
                        onChange: function (value) {
                            // Change event for export selection
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable'); // Reference to the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Restricción de usuarios'),
                                        TypeReport: 'Excel', // Report type
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Restricción de usuarios'),
                                    ignore: {
                                        detailTittle: true, // Ignore detail title in export
                                        Action: true, // Ignore Action column
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    this.app.callEvent('export:data', [
                                        // Trigger export event
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                _('Restricción de usuarios'),
                                            TypeReport: 'PDF', // Report type
                                        },
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Restricción de usuarios'),
                                        autowidth: true, // Auto width for PDF
                                        ignore: {
                                            detailTittle: true, // Ignore detail title in export
                                            Action: true, // Ignore Action column
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this), // Bind context
                    },
                },
            ],
        };
        const left = {
            css: 'int-left', // CSS class for left panel
            rows: [
                // Rows in the left panel
                {
                    view: 'toolbar', // Toolbar for user restriction title
                    css: theme, // Apply theme
                    elements: [
                        { view: 'label', label: _('Restricción de usuarios') }, // Title label
                        {
                            type: 'wide', // Wide button for search
                            css: 'close-bottom',
                            id: 'button-search', // Unique identifier for search button
                            cols: [
                                {
                                    view: 'icon', // Icon for search
                                    icon: 'wxi-search',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        // Click event to show filter popup
                                        $$('filterPopup').show();
                                    },
                                },
                            ],
                        },
                        {
                            type: 'wide', // Wide button for close
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Icon for close
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                Filter, // Include Filter component
                Table, // Include Table component
                toolbar, // Include toolbar
            ],
        };
        webix.ui.fullScreen(); // Set UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                // Rows in the form
                {
                    responsive: 'a5', // Responsive design for the form
                    type: 'wide', // Wide type for layout
                    cols: [left], // Include left panel
                },
            ],
        };
    }

    /**
     * Initializes the MenuView and sets up event listeners.
     * @param {Object} grid - Reference to the grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Execute when Webix is ready
            if (screen.width < 500 || screen.height < 500) {
                $$('toolbar').hide(); // Hide toolbar on small screens
            }
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide(); // Hide search button on larger screens
            }
            $.fn.scrollBottom = function () {
                // Custom jQuery function to get scroll bottom position
                return $$(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
